let Constants = {
    productTypes: {
        "A": "不限",
        "P": "普货",
        "TA": "特货A",
        "TB": "特货B",
        "TC": "特货C"
    },
    xiapiOrderStatus: {
        "ALL": "全部订单",
        "UNPAID": "待付款订单",
        "RETRY_SHIP": "RETRY_SHIP(二次配送)",
        "READY_TO_SHIP": "待出货",
        "SHIPPED": "运送中",
        "TO_CONFIRM_RECEIVE": "待确认收货",
        "COMPLETED": "已完成",
        "IN_CANCEL": "取消中",
        "CANCELLED": "已取消",
        "TO_RETURN": "退款中",

    },
    xiapiOrderSteps: {
        "UNPAID": 0,
        "RETRY_SHIP": 1,
        "READY_TO_SHIP": 2,
        "PROCESSED": 2,
        "SHIPPED": 3,
        "TO_CONFIRM_RECEIVE": 4,
        "COMPLETED": 5,
        "IN_CANCEL": 6,
        "CANCELLED": 7,
        "TO_RETURN": 8,

    },
    moneyChangeTypes: {
        "1": "手动上分",
        "2": "手动下分",
        "3": "代贴收入",
        "4": "代贴退回",
        "5": "申请提现",
        "6": "提现驳回",
        "7": "贴单手续费",
        "8": "国内退货寄件",
        "9": "国内退货寄件撤回",
        "10": "集运费用"
    },
    shopTypes: {
        "1": "台湾（店配）",
        "2": "台湾（宅配）",
        "3": "马来",
        "4": "菲律宾",
        "5": "新加坡",
        "6": "越南",
        "7": "印尼",
        "8": "泰国",
        "9": "巴西",
        "10": "墨西哥"

    },
    areaTypes: {
        "TW": "台湾",
        "MY": "马来",
        "PH": "菲律宾",
        "SG": "新加坡",
        "VN": "越南",
        "ID": "印尼",
        "TH": "泰国",
        "BR": "巴西",
        "MX": "墨西哥"
    },
    shopTypesCode: {
        "TW1": "1",
        "TW2": "2",
        "MY": "3",
        "PH": "4",
        "SG": "5",
        "VN": "6",
        "ID": "7",
        "TH": "8",
        "BR": "9",
        "MX": "10"

    },
    shopCodeToTypes: {
        "1": "TW",
        "2": "TW",
        "3": "MY",
        "4": "PH",
        "5": "SG",
        "6": "VN",
        "7": "ID",
        "8": "TH",
        "9": "BR",
        "10": "MX"

    },
    withdrawStates: {

        "1": "已审核待签收中",
        "2": "已签收待出库",
        "4": "出库完成",
        "8": "本土已签收",
        "-2": "订单取消"

    },
    waybillSteps: {
        "1": 1,
        "2": 2,
        "4": 3,
        "8": 4,
        "-2": 5

    },
    xiapiOrderStatusClass: {
        "ALL": "全部订单",
        "UNPAID": "state-default-full",
        "RETRY_SHIP": "state-error-full",
        "READY_TO_SHIP": "state-error-full",
        "SHIPPED": "state-primary-full",
        "TO_CONFIRM_RECEIVE": "state-info-full",
        "COMPLETED": "state-success-full",
        "IN_CANCEL": "state-error-full",
        "CANCELLED": "state-error-full",
        "TO_RETURN": "state-error-full",

    }
}

Constants.getMoneyChangeType = function(key) {

    return Constants.moneyChangeTypes[key];
    // body...
}
Constants.getWithdrawState = function(key) {

    return Constants.withdrawStates[key];
    // body...
}
Constants.getShopType = function(key) {

    return Constants.shopTypes[key];
    // body...
}
Constants.getXiapiOrderStatus = function(key) {

    return Constants.xiapiOrderStatus[key];
    // body...
}
Constants.getXiapiOrderStatusClass = function(key) {

    return Constants.xiapiOrderStatusClass[key];
    // body...
}
export default Constants;